// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1_Uao","clinicsSelect":"TableHeading_clinicsSelect__2Ub64"};